import React from 'react';
import { withStyles } from './../../../../themes/default';
import { Buttons } from './../../../../components/includes/container';
import { Btn } from './../../../../components/includes/ui';

const styles = theme => ({

});

class NotFoundComponent extends React.Component {

  render(){
    return(
      <Buttons align="center">
        <Btn color="success" variant="contained" icon="add">Seleccionar un componente</Btn>
      </Buttons>
    )
  }

}

export default withStyles(styles)(NotFoundComponent);
